document.addEventListener('DOMContentLoaded', function() {
  // Search functionality
  const brandSearch = document.getElementById('brandSearch');
  const brandSections = document.querySelectorAll('.brand_section');
  const alphabetNav = document.querySelector('.alphabet_navigation');
  const alphabetLinks = document.querySelectorAll('.alphabet_link');

  brandSearch.addEventListener('input', function(e) {
    const searchTerm = e.target.value.toLowerCase();
    let visibleSectionCount = 0;

    // First, hide all alphabet links
    alphabetLinks.forEach(link => {
      link.style.display = 'none';
    });

    brandSections.forEach(section => {
      const links = section.querySelectorAll('.brand_link');
      let hasVisibleBrands = false;

      links.forEach(link => {
        const brandName = link.textContent.toLowerCase();
        if (brandName.includes(searchTerm)) {
          link.style.display = 'block';
          hasVisibleBrands = true;
        } else {
          link.style.display = 'none';
        }
      });

      // Show/hide section based on visible brands
      section.style.display = hasVisibleBrands ? 'block' : 'none';

      // Show corresponding alphabet link only if section has visible brands
      if (hasVisibleBrands) {
        const sectionId = section.getAttribute('id');
        const correspondingLink = document.querySelector(`a[href="#${sectionId}"]`);
        if (correspondingLink) {
          correspondingLink.style.display = 'inline-block';
          visibleSectionCount++;
        }
      }
    });

    // Optional: Hide entire alphabet navigation if no sections are visible
    if (alphabetNav) {
      alphabetNav.style.display = visibleSectionCount > 0 ? 'block' : 'none';
    }
  });
});